import React from 'react';

const PDFViewer = ({ fileUrl }) => {
    return (
        <div style={{ width: '100%', height: '70vh' }}>
            <iframe
                src={fileUrl}
                title="PDF Preview"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            ></iframe>
        </div>
    );
};

export default PDFViewer;
